"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MN = void 0;
exports.MN = {
    numericCode: '496',
    alpha2Code: 'MN',
    alpha3Code: 'MNG',
    englishName: {
        short: 'Mongolia',
        full: 'Mongolia',
    },
    names: {
        full: {
            en: 'Mongolia',
            fr: 'Mongolie (la)',
            mn: 'Mongol',
        },
        short: {
            en: 'Mongolia',
            fr: 'Mongolie (la)',
            mn: 'Mongol',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'mn',
            languageAlpha3Code: 'mon',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'MN-035': {
            numericCode: '496',
            code: 'MN-035',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Orhon',
            },
        },
        'MN-037': {
            numericCode: '496',
            code: 'MN-037',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Darhan uul',
            },
        },
        'MN-039': {
            numericCode: '496',
            code: 'MN-039',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Hentiy',
            },
        },
        'MN-041': {
            numericCode: '496',
            code: 'MN-041',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Hövsgöl',
            },
        },
        'MN-043': {
            numericCode: '496',
            code: 'MN-043',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Hovd',
            },
        },
        'MN-046': {
            numericCode: '496',
            code: 'MN-046',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Uvs',
            },
        },
        'MN-047': {
            numericCode: '496',
            code: 'MN-047',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Töv',
            },
        },
        'MN-049': {
            numericCode: '496',
            code: 'MN-049',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Selenge',
            },
        },
        'MN-051': {
            numericCode: '496',
            code: 'MN-051',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Sühbaatar',
            },
        },
        'MN-053': {
            numericCode: '496',
            code: 'MN-053',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Ömnögovĭ',
            },
        },
        'MN-055': {
            numericCode: '496',
            code: 'MN-055',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Övörhangay',
            },
        },
        'MN-057': {
            numericCode: '496',
            code: 'MN-057',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Dzavhan',
            },
        },
        'MN-059': {
            numericCode: '496',
            code: 'MN-059',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Dundgovĭ',
            },
        },
        'MN-061': {
            numericCode: '496',
            code: 'MN-061',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Dornod',
            },
        },
        'MN-063': {
            numericCode: '496',
            code: 'MN-063',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Dornogovĭ',
            },
        },
        'MN-064': {
            numericCode: '496',
            code: 'MN-064',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Govĭ-Sümber',
            },
        },
        'MN-065': {
            numericCode: '496',
            code: 'MN-065',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Govĭ-Altay',
            },
        },
        'MN-067': {
            numericCode: '496',
            code: 'MN-067',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Bulgan',
            },
        },
        'MN-069': {
            numericCode: '496',
            code: 'MN-069',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Bayanhongor',
            },
        },
        'MN-071': {
            numericCode: '496',
            code: 'MN-071',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Bayan-Ölgiy',
            },
        },
        'MN-073': {
            numericCode: '496',
            code: 'MN-073',
            category: {
                id: '333',
                names: {
                    en: {
                        singular: 'province',
                        plural: 'provinces',
                    },
                    fr: {
                        singular: 'province',
                        plural: '',
                    },
                    mn: {
                        singular: 'aymag',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Arhangay',
            },
        },
        'MN-1': {
            numericCode: '496',
            code: 'MN-1',
            category: {
                id: '360',
                names: {
                    en: {
                        singular: 'capital city',
                        plural: 'capital cities',
                    },
                    fr: {
                        singular: 'capitale',
                        plural: '',
                    },
                    mn: {
                        singular: 'hot',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                mn: 'Ulaanbaatar',
            },
        },
    },
    cities: [
        {
            name: 'Uliastay',
            subdivision: 'Dzabkhan',
        },
        {
            name: 'Ulaangom',
            subdivision: 'Uvs',
        },
        {
            name: 'Ölgiy',
            subdivision: 'Bayan-Ölgiy',
        },
        {
            name: 'Khovd',
            subdivision: 'Hovd',
        },
        {
            name: 'Altai',
            subdivision: 'Govĭ-Altay',
        },
        {
            name: 'Ulan Bator',
            subdivision: 'Ulaanbaatar',
        },
        {
            name: 'Sühbaatar',
            subdivision: 'Selenge',
        },
        {
            name: 'Murun-kuren',
            subdivision: 'Hövsgöl',
        },
        {
            name: 'Mandalgovi',
            subdivision: 'Middle Govĭ',
        },
        {
            name: 'Hovd',
            subdivision: 'Övörhangay',
        },
        {
            name: 'Erdenet',
            subdivision: 'Orhon',
        },
        {
            name: 'Dzüünharaa',
            subdivision: 'Selenge',
        },
        {
            name: 'Darhan',
            subdivision: 'Darhan Uul',
        },
        {
            name: 'Dalandzadgad',
            subdivision: 'Ömnögovĭ',
        },
        {
            name: 'Saynshand',
            subdivision: 'East Gobi Aymag',
        },
        {
            name: 'Bulgan',
            subdivision: 'Bulgan',
        },
        {
            name: 'Bayanhongor',
            subdivision: 'Bayanhongor',
        },
        {
            name: 'Bayanhongor',
            subdivision: 'Bayanhongor',
        },
        {
            name: 'Baruun-Urt',
            subdivision: 'Sühbaatar',
        },
        {
            name: 'Arvayheer',
            subdivision: 'Övörhangay',
        },
        {
            name: 'Зуунмод',
            subdivision: 'Central Aimak',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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